import { render } from "./MyBanner.vue?vue&type=template&id=86b39f0a"
import script from "./MyBanner.vue?vue&type=script&lang=js"
export * from "./MyBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__